exports = module.exports = require("../../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._54HZP0ynKAzwy9pgiZfTA{width:265px}._1PLz8uTHY4kSXl8TBhexcD{width:55px}.nPXv4T7cuEx2Wo6xOpmg-{position:fixed;top:48px;width:320px;bottom:0;z-index:1000001}html[dir=ltr] .nPXv4T7cuEx2Wo6xOpmg-{right:0}html[dir=rtl] .nPXv4T7cuEx2Wo6xOpmg-{left:0}.nPXv4T7cuEx2Wo6xOpmg->div{height:100%}", ""]);
// Exports
exports.locals = {
	"contentPane": "_54HZP0ynKAzwy9pgiZfTA",
	"sideBar": "_1PLz8uTHY4kSXl8TBhexcD",
	"swx": "nPXv4T7cuEx2Wo6xOpmg-"
};